export class ObjectImportModel {
  Content: any;
  OverwriteExisting: boolean = false;
}
